// src/components/JournalistSearchScreen.js
import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust path
import './JournalistSearchScreen.css';

function JournalistSearchScreen() {
  // Search states
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedLetter, setSelectedLetter] = useState('');
  const [journalists, setJournalists] = useState([]);

  // Selected journalist details
  const [selectedJournalist, setSelectedJournalist] = useState(null);
  const [journalistPosts, setJournalistPosts] = useState([]);

  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  // Fetch journalists when searchTerm or selectedLetter changes
  useEffect(() => {
    fetchJournalists();
    // eslint-disable-next-line
  }, [searchTerm, selectedLetter]);

  // Fetch journalists who are isJournalist = true
  async function fetchJournalists() {
    try {
      // Base query: isJournalist = true
      let q = query(collection(db, 'users'), where('isJournalist', '==', true));

      // If we have a searchTerm, filter by username
      // Firestore requires an index for multiple range queries on the same field
      if (searchTerm) {
        // We'll do a "startsWith" approach
        q = query(
          collection(db, 'users'),
          where('isJournalist', '==', true),
          where('username', '>=', searchTerm),
          where('username', '<=', searchTerm + '\uf8ff')
        );
      } else if (selectedLetter) {
        // Filter by letter
        q = query(
          collection(db, 'users'),
          where('isJournalist', '==', true),
          where('username', '>=', selectedLetter),
          where('username', '<=', selectedLetter + '\uf8ff')
        );
      }

      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() });
      });
      setJournalists(results);
    } catch (error) {
      console.error('Error fetching journalists:', error);
    }
  }

  // Handle selecting a journalist to view their posts
  async function handleSelectJournalist(journalist) {
    setSelectedJournalist(journalist);
    // Fetch that journalist's posts (if stored in 'posts' with userId)
    try {
      const q = query(
        collection(db, 'posts'),
        where('userId', '==', journalist.id) // or journalist.uid
      );
      const querySnapshot = await getDocs(q);
      const posts = [];
      querySnapshot.forEach((doc) => {
        posts.push({ id: doc.id, ...doc.data() });
      });
      setJournalistPosts(posts);
    } catch (error) {
      console.error('Error fetching posts:', error);
    }
  }

  // Like / Share / Comment placeholders
  function handleLike(postId) {
    alert(`Liked post ${postId}`);
  }
  function handleShare(postId) {
    alert(`Shared post ${postId}`);
  }
  function handleComment(postId) {
    alert(`Comment on post ${postId}`);
  }

  return (
    <div className="journalist-container">
      {/* Header */}
      <header className="journalist-header">
        <h2>Journalist Search</h2>
      </header>

      {/* Search Bar */}
      <div className="journalist-search-bar">
        <input
          type="text"
          placeholder="Search by username..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setSelectedLetter(''); // Clear letter if typing
          }}
        />
      </div>

      {/* Alphabetical List */}
      <div className="alphabet-list">
        {letters.map((letter) => (
          <button
            key={letter}
            className={`alpha-btn ${
              selectedLetter === letter ? 'active' : ''
            }`}
            onClick={() => {
              setSelectedLetter(letter);
              setSearchTerm('');
            }}
          >
            {letter}
          </button>
        ))}
      </div>

      {/* Journalist Grid */}
      <div className="journalist-grid">
        {journalists.map((j) => (
          <div
            key={j.id}
            className="journalist-card"
            onClick={() => handleSelectJournalist(j)}
          >
            <img
              src={j.profileImage || '/user-placeholder.png'}
              alt="Journalist"
              className="journalist-avatar"
            />
            <p className="journalist-username">{j.username}</p>
          </div>
        ))}
      </div>

      {/* Selected Journalist Panel */}
      {selectedJournalist && (
        <div className="selected-journalist-panel">
          <h3>Selection Appears Here</h3>
          <div className="selected-journalist-info">
            <img
              src={
                selectedJournalist.profileImage || '/user-placeholder.png'
              }
              alt="Selected Journalist"
              className="journalist-avatar"
            />
            <div>
              <p className="journalist-username">
                {selectedJournalist.username}
              </p>
              {/* Possibly display name, rating, etc. */}
            </div>
          </div>

          {/* Journalist's Posts */}
          <div className="journalist-posts">
            {journalistPosts.length === 0 ? (
              <p>No videos found for this journalist.</p>
            ) : (
              journalistPosts.map((post) => (
                <div key={post.id} className="post-card">
                  <h4>{post.title || 'Video Title'}</h4>
                  <p>{post.description || 'No description'}</p>
                  <p>Date: {post.date || 'N/A'}</p>
                  {/* Like / Share / Comment */}
                  <div className="post-actions">
                    <button onClick={() => handleLike(post.id)}>Like</button>
                    <button onClick={() => handleShare(post.id)}>Share</button>
                    <button onClick={() => handleComment(post.id)}>
                      Comment
                    </button>
                  </div>
                  {/* Comments could appear below if you expand this further */}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default JournalistSearchScreen;
